import React, { Component } from "react"
import { observer, inject } from "mobx-react"
import "app/pages/login/Index.scss"
import "./Index.scss"

@inject("auth")@observer
export default class Index extends Component {
  render() {
    const { auth: { userInfo }, children } = this.props

    return (
      <div className="page-front-login-sp">
        <h1 className="logo-img">PGC CLOUD</h1>
        <h2 className="logo-user">欢迎您，<span className="logo-username">{userInfo.truename}</span></h2>
        { children }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/WelcomeContainer/index.js